import { observable, action } from "mobx";
import News from "../models/News";
import StrapiHelper from "../services/StrapiHelper.service";
import { toastError } from "../services/toast";

export default class NewsStore {
  @observable
  news: News[] = [];

  @observable
  currentNews?: News;

  @action
  setCurrentNews(news?: News) {
    this.currentNews = news;
  }

  @action
  async loadNewsArticle(id: string) {
    try {
      let res = await StrapiHelper.loadNewsArticle(id);
      let event = res.data as News;
      this.currentNews = event;
    } catch (err) {
      toastError(err, () => this.loadNewsArticle(id));
    }
  }

  @action
  async loadNews() {
    try {
      let res = await StrapiHelper.loadNews();
      let news = res.data as News[];
      this.news = news;
    } catch (err) {
      toastError(err, () => this.loadNews());
    }
  }
}
